// extracted by mini-css-extract-plugin
module.exports = {"host":"o2-theme_host__FcuqZ"};